import React from 'react';
import FitnessProfileSectionCard from '../shared/FitnessProfileSectionCard';
import FitnessHubsOnlyToggle from '../shared/FitnessHubsOnlyToggle';

export default function FitnessProfileSettingsSection({
	fitnessHubsOnly,
	onFitnessHubsOnlyChange,
	canEdit,
	saving,
	error
}) {
	return (
		<div className="mt-4">
			<FitnessProfileSectionCard title="Profile settings">
				<FitnessHubsOnlyToggle
					checked={fitnessHubsOnly}
					onChange={onFitnessHubsOnlyChange}
					disabled={!canEdit || saving}
				/>
				{error && (
					<p className="mt-3 text-sm text-red-600 dark:text-red-400" role="alert">
						{error}
					</p>
				)}
			</FitnessProfileSectionCard>
		</div>
	);
}
